import * as React from 'react';
import * as styled from './styled';
import AppStore, {Theme} from 'stores/AppStore';
import {observer} from 'mobx-react';
import {ThemeSwitchProps} from './types';

/**
 * The switch control.
 * @param {ThemeSwitchProps} props
 * @return {React.ReactElement<ThemeSwitchProps>}
 * @constructor
 */
function ThemeSwitch(
    props: ThemeSwitchProps,
): React.ReactElement<ThemeSwitchProps> {
  console.log(AppStore.theme);

  /**
   * Render input.
   * @return {JSX.Element}
   */
  function renderInput(): JSX.Element {
    /**
     * The change event handler.
     * @return {void}
     */
    function handleChange(): void {
      if (AppStore.theme === Theme.Dark) {
        AppStore.theme = Theme.Light;
      } else if (AppStore.theme === Theme.Light) {
        AppStore.theme = Theme.Dark;
      }
    }

    return (
      <styled.Input
        type="checkbox"
        checked={AppStore.theme === Theme.Light}
        onChange={handleChange}
      />
    );
  }

  /**
   * Render round.
   * @return {JSX.Element}
   */
  function renderRound(): JSX.Element {
    return (
      <styled.Round />
    );
  }

  return (
    <styled.Wrapper>
      {renderInput()}
      <styled.Container>
        {renderRound()}
      </styled.Container>
    </styled.Wrapper>
  );
}

export default observer(ThemeSwitch);
